import { TableRow, styled, } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: 52,
  borderTop: `1px solid ${theme.palette.divider}`,

  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.grey[50],
  },

  '&:last-of-type(even)': {
    borderBottom: 'none'
  }
}));
